<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<div class="w-1/2">
					<div class="pt-2 pa-0 justify-center md:gap-1 flex-grow items-baseline md:w-full" style="align-self: start; align-content: start">
						<div class="flex mb-6">
							<div class="font-bold mr-5" style="color: #495057">
								{{ $t('company_logo') }}
							</div>
							<div class="flex rounded-full h-6 w-6 justify-center cursor-pointer tooltip" style="background-color: lightgrey; align-items: center">
								<font-awesome-icon :icon="['fas', 'info']" class="flex justify-center text-connectProBlue" style="align-content: center" />
								<div class="tooltiptext">
									{{ $t('admin_cuts_file_two_days') }}
								</div>
							</div>
							<div class="ml-5 mt-1 parent" v-if="value.companyLogo != null">
								<font-awesome-icon
									:icon="value.logoUnblockedByAdmin ? ['fas', 'check'] : ['fas', 'question']"
									alt="hhs"
									class="flex justify-center text-connectProBlue cursor-pointer"
									style="align-content: center"
								/>
								<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">
									{{ value.logoUnblockedByAdmin ? $t('unblocked') : $t('needs_check') }}
								</div>
							</div>
						</div>
						<div class="flex gap-3">
							<BaseButton
								v-if="companyLogo != null"
								@click="downloadAsset(true)"
								class="w-full sm:w-auto mt-6 sm:mt-0 justify-center flex"
								style="align-self: start"
							>
								<font-awesome-icon :icon="['fas', 'download']" class="w-5 h-5 pr-1 pt-1 justify-center" size="lg" />
								{{ $t('download') }}
							</BaseButton>
							<BaseButton @click="openUpload('logo')" class="w-full sm:w-auto mt-6 sm:mt-0 justify-center flex" style="align-self: start">
								<input type="file" ref="file" accept="image/png, image/jpg, image/bmp, image/jpeg" @change="chosenLogo(true)" class="hidden" />
								<font-awesome-icon :icon="['fas', 'image']" class="w-5 h-5 pr-1 pt-1 justify-center" size="lg" />
								{{ $t('pick_file') }}
							</BaseButton>
						</div>

						<div class="w-full flex flex-shrink justify-start mt-4 mb-4">
							<div
								v-if="companyLogo"
								class="flex mb-4 justify-start w-full mr-5"
								style="width: fit-content"
								@mouseover="hover = true"
								@mouseleave="hover = false"
							>
								<img
									alt=" "
									:src="companyLogo"
									@load="isLoaded = true"
									class="justify-center w-full"
									style="align-content: center; text-align: center; object-fit: fill; background: #e4e5e4;"
								/>
							</div>
							<div v-else class="bg-gray-300" style=" width: 200px; height: 117px" />
						</div>
						<div class="w-full flex justify-start">
							<BaseButton
								@click="
									companyLogo = null;
									$store.commit('setConfirmLeaving', $t('leave_page'));
								"
								>{{ $t('delete') }}</BaseButton
							>
						</div>
						<div>
							<BaseSelect
								class="w-1/2 mt-6"
								ref="BaseSelect.logoPosition"
								:label="$t('logo_position_description')"
								:options="logoPositionOptions"
								v-model="selectedLogoPosition"
								options-label="display"
								track-by="value"
								:required="false"
								:multiple="false"
								font="normal"
							/>
						</div>
					</div>
				</div>
				<div class="w-1/2">
					<div class="pt-2 pa-0 justify-center md:gap-1 flex-grow items-baseline md:w-full" style="align-self: start; align-content: start">
						<div class="flex mb-6">
							<div class="font-bold mr-5" style="color: #495057">
								{{ $t('letter_header') }}
							</div>
							<div class="flex rounded-full h-6 w-6 justify-center cursor-pointer tooltip" style="background-color: lightgrey; align-items: center">
								<font-awesome-icon :icon="['fas', 'info']" class="flex justify-center text-connectProBlue" style="align-content: center" />
								<div class="tooltiptext">
									{{ $t('admin_cuts_letter_header_two_days') }}
								</div>
							</div>
							<div class="ml-5 mt-1 parent" v-if="value.letterHeader != null">
								<font-awesome-icon
									:icon="value.letterHeaderUnblockedByAdmin ? ['fas', 'check'] : ['fas', 'question']"
									class="flex justify-center text-connectProBlue cursor-pointer"
									style="align-content: center"
								/>
								<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">
									{{ value.letterHeaderUnblockedByAdmin ? $t('unblocked') : $t('needs_check') }}
								</div>
							</div>
						</div>
						<div class="flex gap-3">
							<BaseButton
								v-if="letterHeader != null"
								@click="downloadLetterHeader"
								class="w-full sm:w-auto mt-6 sm:mt-0 justify-center flex"
								style="align-self: start"
							>
								<font-awesome-icon :icon="['fas', 'download']" class="w-5 h-5 pr-1 pt-1 justify-start" size="lg" />
								{{ $t('download') }}
							</BaseButton>
							<BaseButton @click="openUpload('letterHeader')" class="w-full sm:w-auto mt-6 sm:mt-0 justify-center flex" style="align-self: start">
								<input type="file" ref="letter" accept="image/png, image/jpg, image/bmp, image/jpeg" @change="chosenFile(false)" class="hidden" />
								<font-awesome-icon :icon="['fas', 'image']" class="w-5 h-5 pr-1 pt-1 justify-start" size="lg" />
								{{ $t('pick_file') }}
							</BaseButton>
						</div>
						<div class="w-full flex justify-start mt-4 mb-4">
							<div
								v-if="letterHeader"
								class="flex mb-4 justify-start w-full"
								style="width: fit-content"
								@mouseover="hoverLetter = true"
								@mouseleave="hoverLetter = false"
							>
								<img
									alt=" "
									:src="letterHeader"
									@load="isLoaded = true"
									class="justify-center w-full"
									style="align-content: center; text-align: center; object-fit: fill; background: #e4e5e4;"
								/>
							</div>
							<div v-else class="bg-gray-300" style="width: 200px; height: 117px" />
						</div>
						<div class="w-full flex justify-start">
							<BaseButton
								@click="
									letterHeader = null;
									$store.commit('setConfirmLeaving', $t('leave_page'));
								"
								>{{ $t('delete') }}</BaseButton
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import Authentication from '@/mixins/Authentication';

export default {
	components: { BaseButton, BaseSelect },
	name: 'OnboardingCompanyAssetsForm',
	mixins: [Authentication],
	props: {
		value: {},
	},
	data() {
		return {
			companyLogo: null,
			letterHeader: null,
			hoverLetter: false,
			hover: false,
			filePickerOpen: false,
			logoPositionOptions: [
				{ display: 'Links', value: 'left' },
				{ display: 'Mittig', value: 'center' },
				{ display: 'Rechts', value: 'right' },
			],
			isLoaded: false,
			selectedLogoPosition: null,
		};
	},
	methods: {
		downloadAsset(isLogo) {
			const a = document.createElement('a');
			a.href = this.companyLogo;
			if (isLogo) {
				a.download = `${this.value.name}_logo.png`;
			} else {
				a.download = `${this.value.name}_sign.png`;
			}

			a.click();
		},
		downloadLetterHeader() {
			const a = document.createElement('a');
			a.href = this.letterHeader;
			a.download = `${this.value.name}_briefkopf.png`;
			a.click();
		},
		openUpload(type) {
			if (!this.filePickerOpen) {
				switch (type) {
					case 'logo':
						{
							this.$swal(this.$t('general.hint').toString(), this.$t('logo_hint').toString(), 'info').then(alert => {
								this.filePickerOpen = true;
								this.$refs.file.click();
								this.filePickerOpen = false;
							});
						}
						break;
					case 'letterHeader':
						{
							this.$swal(this.$t('general.hint').toString(), this.$t('letter_header_hint').toString(), 'info').then(alert => {
								this.filePickerOpen = true;
								this.$refs.letter.click();
								this.filePickerOpen = false;
							});
						}
						break;
					default: {
						this.filePickerOpen = true;
						this.$refs.sign.click();
						this.filePickerOpen = false;
					}
				}
			}
		},
		chosenFile(isSign) {
			this.filePickerOpen = false;
			let file;
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			if (isSign) {
				file = this.$refs.sign.files[0];
				if (!this.isUserAllowedInLevel1) {
					this.value.signUnblockedByAdmin = false;
				}
			} else {
				file = this.$refs.letter.files[0];
				if (!this.isUserAllowedInLevel1) {
					this.value.letterHeaderUnblockedByAdmin = false;
				}
			}

			const reader = new FileReader();

			reader.onload = e => {
				if (isSign) {
					this.companySign = e.target.result;
				} else {
					this.letterHeader = e.target.result;
				}
			};

			reader.readAsDataURL(file);
		},
		chosenLogo() {
			this.filePickerOpen = false;
			const oldImage = this.companyLogo;
			const file = this.$refs.file.files[0];
			const reader = new FileReader();
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			if (!this.isUserAllowedInLevel1) {
				this.value.logoUnblockedByAdmin = false;
			}

			if (!file.type.startsWith('image/')) {
				return false;
			}

			const i = new Image();
			// eslint-disable-next-line @typescript-eslint/no-this-alias
			const context = this;

			i.onload = function() {
				if (i.height < 500 && i.width < 500) {
					context.$swal(context.$t('general.attention').toString(), context.$t('upload_in_better_quality').toString(), 'warning');
					context.companyLogo = oldImage;
				}
			};

			reader.onload = e => {
				this.companyLogo = e.target.result;
				i.src = this.companyLogo;
			};

			reader.readAsDataURL(file);
		},
		getData() {
			return { companyLogo: this.companyLogo, logoPosition: this.selectedLogoPosition?.value, letterHeader: this.letterHeader };
		},
	},
};
</script>
